<template>
  <div class="sendFlower">
    <div
      v-if="livingStatus == 'living'"
      id="flowerbox"
      v-show="showFlower"
      ref="flowerbox"
    >
      <div class="demo">
        <img
          v-for="(item, index) in huabanList"
          :key="index"
          :src="item"
          class="huaban"
          ref="huaban"
        />
      </div>
      <img
        src="http://cdn.yxvzb.com/newWechat/image/%E9%80%81%E8%8A%B1@2x.png"
        id="gift1"
      />
      <div id="dbl_click" class="lecture_length" @click="clickOrDblClick"></div>
      <img
        src="//cdn.yxvzb.com/img/flower/close.png"
        id="gift_close"
        @click="closeFlowerBox"
      />
    </div>
    <div id="danmu">
      <ul class="list-wrapper" ref="danmuUl">
        <li
          v-for="(item, index) in danmuList"
          :key="index"
          ref="danmuList"
          style="display:none"
        >
          {{ item.text }}
        </li>
      </ul>
      <transition-group
        name="slide"
        tag="ul"
        class="list-wrapper"
      ></transition-group>
    </div>
    <div id="gift">
      <ul class="list-wrapper" ref="giftUl">
        <div>
          <transition
            enter-active-class="animated bounceInLeft"
            leave-active-class="animated bounceOutLeft"
            :duration="{ enter: 1000, leave: 1000 }"
            v-on:after-leave="afterLeave1"
            v-on:before-leave="beforeLeave1"
          >
            <li v-show="giftFlag1">
              <div>
                <span class="giftUserName">{{ giftObj1.userName }}</span>
                送老师{{
                  giftObj1.giftCount == 1 ? '一' : giftObj1.giftCount
                }}个
                <img :src="giftObj1.giftImg" />
              </div>
              <img src="http://cdn.yxvzb.com/WEB/wx-master/images/mult.png" />
              <h2 ref="count1">{{ count1 }}</h2>
            </li>
          </transition>
        </div>
        <div>
          <transition
            enter-active-class="animated bounceInLeft"
            leave-active-class="animated bounceOutLeft"
            :duration="{ enter: 1000, leave: 1000 }"
            v-on:after-leave="afterLeave2"
            v-on:before-leave="beforeLeave2"
          >
            <li v-show="giftFlag2">
              <div>
                <span class="giftUserName">{{ giftObj2.userName }}</span>
                送老师{{
                  giftObj2.giftCount == 1 ? '一' : giftObj2.giftCount
                }}个
                <img :src="giftObj2.giftImg" />
              </div>
              <img src="http://cdn.yxvzb.com/WEB/wx-master/images/mult.png" />
              <h2 class="animated rubberBand" ref="count2">{{ count2 }}</h2>
            </li>
          </transition>
        </div>
      </ul>
    </div>
    <div v-show="hideFlag" style="position:absolute;top:0;width:100%;left:0;">
      <img
        src="https://cdn.yxvzb.com/WEB/wx-master/images/Group%202.png"
        style="width:.8rem;height:.4rem;margin:auto;display:block;"
        @click="
          hideFlag = false;
          queFlag = true;
        "
      />
    </div>
    <transition
      enter-active-class="animated bounceInDown"
      leave-active-class="animated bounceOutUp"
      :duration="{ enter: 1000, leave: 1000 }"
      v-on:after-leave="afterLeave2"
    >
      <div
        v-show="queFlag"
        v-if="queList.length != 0"
        id="question"
        @touchmove.prevent
      >
        <!-- <img src="//cdn.yxvzb.com/WEB/wx-master/images/close.png" class="queImg"  @click='showQueOrNot'/> -->
        <div class="queBox" v-if="imgFlag">
          <checklist
            v-if="queList[queIndex].selectedType == 1"
            :title="queList[queIndex].title"
            label-position="right"
            required
            :options="queList[queIndex].ansList"
            v-model="queList[queIndex].ans"
            @on-change="change"
            :min="1"
            :max="1"
          ></checklist>
          <checklist
            v-else
            :title="queList[queIndex].title"
            label-position="right"
            required
            :options="queList[queIndex].ansList"
            v-model="queList[queIndex].ans"
            @on-change="change"
            :min="1"
            :max="4"
          ></checklist>
          <x-button
            :plain="true"
            type="primary"
            style="color:#161616;width:6.4rem;height:.93rem;padding-left:0;padding-right:0;font-size:.43rem;border:1px solid #979797;border-radius:.47rem;margin-top:.3rem;"
            @click.native="send"
            :disabled="ifDis"
            :class="[ifDis ? 'disabl' : '']"
          >
            {{ queIndex == queList.length - 1 ? '提交' : '下一题' }}
          </x-button>
        </div>
        <div
          class="closeQueBox"
          @click="
            queFlag = false;
            hideFlag = true;
          "
        >
          ×
        </div>
      </div>
    </transition>
    <gift
      :show-gift-window="showGiftWindow"
      @lectrueLength="getTimes"
      :detailObj="detailObj"
    ></gift>
    <toast v-model="showToa" type="warn" width="12em">您有未完成的题目</toast>
  </div>
</template>
<script>
import Gift from './gift.vue';
import { mapMutations, mapState, mapActions } from 'vuex';
// TODO: vux
import { Checklist, XButton, Toast } from 'vux';
import { setTimeout, clearTimeout } from 'timers';
import { live } from '@/api/ajax.js';
export default {
  name: '',
  props: {
    detailObj: {
      type: Object,
      default: function() {
        return {};
      }
    },
    livingStatus: {
      default: ''
    },
    transList: {
      type: Object,
      default: () => {
        return {};
      }
    },
    transCom: {
      type: Object,
      default: () => {
        return {};
      }
    },
    examFlag: {
      //开始答题信号
      type: Number
    }
  },
  data() {
    return {
      imgFlag: true,
      showFlower: true,
      timeArr: [], // 时间戳数组
      count: 0, // 送花计数器
      huabanList: [
        'http://cdn.yxvzb.com/img/flower/1.png',
        'http://cdn.yxvzb.com/img/flower/2.png',
        'http://cdn.yxvzb.com/img/flower/3.png',
        'http://cdn.yxvzb.com/img/flower/4.png',
        'http://cdn.yxvzb.com/img/flower/5.png',
        'http://cdn.yxvzb.com/img/flower/6.png',
        'http://cdn.yxvzb.com/img/flower/7.png'
      ],
      danmuList: [],
      danmuCount: 0,
      giftList: [],
      giftCount: 0,
      // 礼物弹层显示隐藏
      showGiftWindow: 0,
      lectureLength: 0,
      allLecture: 0,
      clickTimer: null,
      lastClickTime: 0,
      // 假控制
      giftSend: false,
      giftObj1: {},
      giftObj2: {},
      giftFlag1: false,
      giftFlag2: false,
      realList: [],
      queFlag: true,
      queList: [],
      queIndex: 0,
      ifDis: false,
      ansFlag: true,
      showToa: false,
      activityId: '',
      hideFlag: false,
      giftList: [],
      count1: 1,
      count2: 1,
      endFlag1: false,
      endFlag2: false,
      timer1: null,
      timer2: null,
      timer3: null,
      timer4: null,
      danmuTimer: null
    };
  },
  methods: {
    beforeLeave1() {},
    beforeLeave2() {},
    showQueOrNot() {
      this.imgFlag = !this.imgFlag;
    },
    getQue() {
      //获取题目
      live
        .getQue({
          courseId: this.$route.params.id,
          userId: this.$api.getStorage('wxUserInfo').id || '',
          openId: this.$api.getStorage('wxUserInfo').wxOpenId || ''
        })
        .then(res => {
          if (
            res.data.status == 'success' &&
            res.data.data.voteQuestions.length != 0
          ) {
            this.queFlag = true;
            this.queList = res.data.data.voteQuestions;
            this.activityId = res.data.data.activityId;
            this.dealQueData();
          }
        });
    },
    send() {
      //提交答案
      var subList = [],
        index = this.queIndex,
        item = this.queList[index];
      if (item.ans.length != 0) {
        //答案不为空
        if (index < this.queList.length - 1) {
          //后面还有题目
          let obj = Object.assign(
            {},
            { questionId: item.id },
            { option: item.ans.join(',') },
            {
              courseId: this.$route.params.id,
              isComplete: 0,
              activityId: this.activityId
            }
          );
          subList.push(obj);
          if (this.ansFlag) {
            this.ansFlag = false;
            live
              .sendAns({
                userId: this.$api.getStorage('wxUserInfo').id || '',
                openId: this.$api.getStorage('wxUserInfo').wxOpenId || '',
                questionListJson: JSON.stringify(subList)
              })
              .then(res => {
                this.ansFlag = true;
                this.queIndex += 1;
              });
          }
        } else {
          //最后一题了
          let obj = Object.assign(
            {},
            { questionId: item.id },
            { option: item.ans.join(',') },
            {
              courseId: this.$route.params.id,
              isComplete: 1,
              activityId: this.activityId
            }
          );
          subList.push(obj);
          if (this.ansFlag) {
            this.ansFlag = false;
            live
              .sendAns({
                userId: this.$api.getStorage('wxUserInfo').id || '',
                openId: this.$api.getStorage('wxUserInfo').wxOpenId || '',
                questionListJson: JSON.stringify(subList)
              })
              .then(res => {
                if (res.data.status != 'success') {
                  this.$vux.toast.text(res.data.message);
                }
                this.ansFlag = true;
                this.queFlag = false;
                this.hideFlag = false;
                this.queList = [];
                this.queIndex = 0;
              });
          }
        }
      } else {
        this.showToa = true;
      }
    },
    change() {
      //答题选项变化
    },
    pushAns(item, list, word) {
      //处理答题数据
      if (item) {
        list.push({
          value: item,
          key: word
        });
      }
    },
    dealQueData() {
      //处理答题数据
      for (var item of this.queList) {
        item.ansList = [];
        this.pushAns(item.optiona, item.ansList, 'a');
        this.pushAns(item.optionb, item.ansList, 'b');
        this.pushAns(item.optionc, item.ansList, 'c');
        this.pushAns(item.optiond, item.ansList, 'd');
        this.pushAns(item.optione, item.ansList, 'e');
        this.pushAns(item.optionf, item.ansList, 'f');
      }
    },
    afterLeave1() {
      this.count1 = 1;
      if (this.realList.length != 0) {
        this.giftObj1 = this.realList[0];
        this.realList.splice(0, 1);
        this.giftFlag1 = true;
        setTimeout(() => {
          this.giftFlag1 = false;
        }, 2000);
      } else {
        this.giftObj1 = {};
      }
    },
    afterLeave2() {
      this.count2 = 1;
      if (this.realList.length != 0) {
        this.giftObj2 = this.realList[0];
        this.realList.splice(0, 1);
        this.giftFlag2 = true;
        setTimeout(() => {
          this.giftFlag2 = false;
        }, 2000);
      } else {
        this.giftObj2 = {};
      }
    },
    ...mapMutations(['CLOSEGIFTBOX']),
    ...mapActions(['flowerCount']),
    closeFlowerBox() {
      this.showFlower = false;
    },
    danmuSendFlower() {},
    // 获取图标上的听课时长
    getLectrueLength() {
      // this.lectureLength = Math.floor(this.$api.getStorage(this.$route.params.id) / 60);
    },
    // 同步听课时长
    getTimes: function(data) {
      // this.lectureLength = data;
    },
    clickOrDblClick() {
      clearTimeout(this.clickTimer);
      var nowTime = new Date().getTime();
      if (nowTime - this.lastClickTime < 1000) {
        /*双击*/
        this.lastClickTime = nowTime;
        // 发送到子组件去清掉缓存和变量
        this.showGiftWindow += 1;
        let userInfo = this.$api.getStorage('wxUserInfo'),
          data = this.giftList[0];
        var giftData = {
          type: 2,
          userName: userInfo.nickName || '',
          userId: userInfo.id || '',
          userClickTime: new Date().getTime(),
          courseId: this.$route.params.id,
          giftType: data.giftType,
          giftCount: 1,
          giftImg: data.icon,
          giftName: data.name,
          name: this.$api.getStorage('wxUserInfo').nickName,
          id: this.$api.getStorage('wxUserInfo').id,
          liveEndTime: this.detailObj.liveEndTime
        };
        window.dmsocket.send(JSON.stringify(giftData));
        live.sendGift({
          giftName: data.giftName,
          giftNum: 1,
          courseId: this.$route.params.id
        });
        // 送礼物埋点
        this.$sa.re_interaction({
          type: '送花' + data.giftType, // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
          contentype: 5, // 互动主体 直播，录播，资讯，病例，站内信，论坛
          contentid: this.$route.params.id, // 内容id
          first_cate: this.categoriesList[0].categoryName, //一级分类
          second_cate: this.categoriesList[1].categoryName, // 2级分类
          first_cate_id: this.categoriesList[0].id, // 1级分类id
          second_cate_id: this.categoriesList[1].id, //2级分类id
          author: this.detailObj.editor || '', //讲师/作者
          contentname: this.detailObj.courseName
          // location:'', //位置 站内，专区内，超级面对面内
        });
      } else {
        /*单击*/
        this.lastClickTime = nowTime;
        this.clickTimer = setTimeout(() => {
          this.CLOSEGIFTBOX(true);
        }, 400);
      }
    },
    reset() {
      for (let item of this.$refs.huaban) {
        item.className = 'huaban';
      }
    },
    plus(item) {
      this.flowerCount(item.count);
    },
    render(item) {
      this.danmuList.push(item);
    },
    giftRender(item) {
      this.realList.push(item);
      this.giftList.push(item);
    }
  },
  computed: {
    ...mapState({
      closeGiftBox: state => state.closeGiftBox,
      categoriesList: state => state.categoriesList
    })
  },
  components: {
    Gift,
    Checklist,
    XButton,
    Toast
  },
  mounted() {
    this.getLectrueLength();
    //this.getQue() //上来获取题目
    live.getGiftList().then(res => {
      if (res.data.status == 'success') {
        this.giftList = res.data.data;
      }
    });
  },
  beforeDestroy() {
    clearTimeout(this.danmuTimer);
  },
  watch: {
    examFlag(n, o) {
      if (n) {
        this.getQue();
      } else {
        this.hideFlag = false;
        this.queFlag = false;
      }
    },
    danmuList(n, o) {
      let l = n.length;
      if (l > this.danmuCount) {
        let min = l - this.danmuCount;
        this.danmuTimer = setTimeout(() => {
          if (this.danmuCount > 5) {
            this.$refs.danmuUl.removeChild(this.$refs.danmuUl.childNodes[0]);
          }
          if (this.$refs.danmuList[l - 1]) {
            this.$refs.danmuList[l - 1].className = 'upani';
            this.danmuCount += 1;
          }
        }, 2000 * min);
      }
    },
    transList(n, o) {
      if (
        this.giftObj1 &&
        this.giftObj1.userId == n.userId &&
        this.giftObj1.giftName == n.giftName &&
        this.giftFlag1
      ) {
        this.count1 += 1;
        clearTimeout(this.timer1);
        this.timer1 = setTimeout(() => {
          this.giftFlag1 = false;
        }, 2000);
      } else if (
        this.giftObj2 &&
        this.giftObj2.userId == n.userId &&
        this.giftObj2.giftName == n.giftName &&
        this.giftFlag2
      ) {
        this.count2 += 1;
        clearTimeout(this.timer2);
        this.timer2 = setTimeout(() => {
          this.giftFlag2 = false;
        }, 2000);
      } else {
        this.realList.push(n);
        if (!this.giftFlag1) {
          this.count1 = 1;
          this.giftObj1 = this.realList[0];
          this.giftFlag1 = true;
          this.realList.splice(0, 1);
          this.timer1 = setTimeout(() => {
            this.giftFlag1 = false;
          }, 2000);
        } else {
          if (!this.giftFlag2) {
            this.count2 = 1;
            this.giftObj2 = this.realList[0];
            this.giftFlag2 = true;
            this.realList.splice(0, 1);
            this.timer2 = setTimeout(() => {
              this.giftFlag2 = false;
            }, 2000);
          }
        }
      }
    },
    transCom(n, o) {
      this.render(n);
    },
    count1(n) {
      if (n > 1) {
        this.$refs.count1.className = '';
        setTimeout(() => {
          this.$refs.count1.className = 'animated rubberBand';
        }, 100);
      }
    },
    count2(n) {
      if (n > 1) {
        this.$refs.count2.className = '';
        setTimeout(() => {
          this.$refs.count2.className = 'animated rubberBand';
        }, 100);
      }
    }
  }
};
</script>
<style lang="less">
.weui-check_label {
  padding: 5px !important;
}
.weui-cells_checkbox {
  // background: transparent !important;
  font-size: 5px !important;
}
.weui-cells:after {
  display: none;
}
.weui-cells:before {
  display: none;
}
.weui-cell:before {
  display: none;
}
.weui-cells__title {
  font-size: 0.4rem !important;
  color: #191919 !important;
}
.weui-cells_checkbox > label > * {
  font-size: 0.32rem;
}
</style>
<style lang="less" scoped>
.queImg {
  width: 0.4rem;
  height: 0.77rem;
  margin-top: 2.6rem;
}
#question {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  top: 7.7rem;
  left: 0;
  position: fixed;
}
.queBox {
  width: 7.87rem;
  height: 6.4rem;
  overflow-y: scroll;
  background: #fff;
  border-radius: 0.21rem;
  margin: auto;
  padding: 0.1rem 0.73rem;
  margin-top: 0.3rem;
}
.closeQueBox {
  font-size: 0.8rem;
  width: 0.93rem;
  height: 0.93rem;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  border-radius: 50%;
  border: 1px solid #fff;
  margin: auto;
  margin-top: 0.61rem;
}
#danmu {
  position: fixed;
  right: 0.267rem;
  bottom: 2.667rem;
  z-index: 30;
  width: 8rem;
  background: #fff;
  li {
    padding: 0.24rem 0.4rem;
    position: absolute;
    max-width: 8rem;
    color: #fff;
    text-align: left;
    border-radius: 0.23rem;
    right: 0.507rem;
    line-height: 0.56rem;
    font-size: 0.4rem;
    background: #1989fe;
    &:after {
      content: '';
      width: 0.4rem;
      height: 0.3rem;
      position: absolute;
      right: -0.2rem;
      bottom: 0.05rem;
      background: url('https://cdn.yxvzb.com/WEB/wx-master/images/rCor.png')
        no-repeat;
      background-size: 100% 100%;
    }
    img {
      width: 0.7rem;
      height: 0.64rem;
    }
  }
}
#gift {
  position: fixed;
  left: 0.267rem;
  top: 8rem;
  z-index: 40;
  div {
    height: 0.91rem;
    margin-bottom: 0.27rem;
  }
  li {
    // width: 4.71rem;
    height: 0.91rem;

    font-size: 0.37rem;
    color: #999999;
    line-height: 0.91rem;
    padding-left: 0.32rem;
    display: flex;
    align-items: center;
    .giftUserName {
      font-size: 0.37rem;
      color: #027cfa;
      line-height: 0.91rem;
    }
    > div {
      background: rgba(232, 243, 255, 0.96);
      border-radius: 0 1.33rem 1.33rem 0;
      padding-left: 0.27rem;
      padding-right: 0.43rem;
      height: 0.91rem;
      line-height: 0.91rem;
      display: flex;
      align-items: center;
    }
    img {
      width: 0.6rem;
      height: 0.6rem;
      vertical-align: middle;
      margin-left: 0.27rem;
      // margin-top: -.2rem;
    }
    h2 {
      background: linear-gradient(to bottom, #6ce5ff, #2992ff);
      -webkit-background-clip: text;
      color: transparent;
      font-size: 0.96rem;
      line-height: 0.96rem;
      margin-top: -0.2rem;
    }
  }
}
#flowerbox {
  width: 1.44rem;
  height: 1.44rem;
  position: fixed;
  right: 0.4rem;
  bottom: 1.59rem;
  z-index: 2;
  #gift1 {
    width: 1.44rem;
    height: 1.466667rem;
    position: absolute;
  }
  .lecture_length {
    position: absolute;
    top: 0%;
    left: 0%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #027cfa;
    font-size: 0.37rem;
    z-index: 99;
  }
  #gift_close {
    width: 0.27rem;
    height: 0.27rem;
    position: absolute;
    right: -0.15rem;
    top: 0;
  }
  .demo {
    img {
      width: 0.533333rem;
      height: 0.533333rem;
      position: absolute;
      bottom: 1.333333rem;
      left: 50%;
      margin-left: -0.133333rem;
      opacity: 0;
    }
  }
}

@-webkit-keyframes gotop {
  0% {
    bottom: 0;
    opacity: 1;
  }
  90% {
    bottom: 6.3rem;
    opacity: 1;
  }
  100% {
    bottom: 7rem;
    opacity: 0;
  }
}

@-webkit-keyframes flower1 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: 1.733rem;
  }
}

@-webkit-keyframes flower2 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: 0.667rem;
  }
}

@-webkit-keyframes flower3 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: 0.933rem;
  }
}

@-webkit-keyframes flower4 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: 0.4rem;
  }
}

@-webkit-keyframes flower5 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: -0.133rem;
  }
}

@-webkit-keyframes flower6 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: -0.533rem;
  }
}

@-webkit-keyframes flower7 {
  from {
    bottom: 1.4rem;
    opacity: 1;
    left: 0.4rem;
  }
  to {
    bottom: 4rem;
    opacity: 0;
    left: -0.8rem;
  }
}

@-webkit-keyframes explode {
  0% {
    font-size: 1rem;
  }
  50% {
    top: 1.2rem;
  }
  100% {
    top: 1rem;
  }
}

.upani {
  display: block !important;
  animation: gotop 5s linear;
  -webkit-animation: gotop 5s linear;
  animation-fill-mode: forwards;
  font-size: 0.32rem;
}

.explodeani {
  animation: explode 500ms;
}

.flowerani0 {
  animation: flower1 2000ms;
  -webkit-animation: flower1 2000ms;
  animation-fill-mode: forwards;
}

.flowerani1 {
  -webkit-animation: flower2 3200ms;
  animation-fill-mode: forwards;
}

.flowerani2 {
  -webkit-animation: flower3 2500ms;
  animation-fill-mode: forwards;
}

.flowerani3 {
  -webkit-animation: flower4 2800ms;
  animation-fill-mode: forwards;
}

.flowerani4 {
  -webkit-animation: flower5 2200ms;
  animation-fill-mode: forwards;
}

.flowerani5 {
  -webkit-animation: flower6 3300ms;
  animation-fill-mode: forwards;
}

.flowerani6 {
  -webkit-animation: flower7 2100ms;
  animation-fill-mode: forwards;
}
</style>
<style lang="less">
.hasPadding {
  position: relative;
}
.send_gift_box {
  position: absolute;
  right: 5%;
  top: 15%;
  width: 4.71rem;
  z-index: 999;
  div {
    margin-bottom: 0.37rem;
    padding: 0.19rem 0;
    width: 100%;
    text-align: center;
    font-size: 0.37rem;
    color: #999999;
    background: rgba(232, 243, 255, 0.96);
    border-radius: 1.33rem 0.11rem 0.11rem 1.33rem;
    span:nth-of-type(1) {
      padding-right: 0.16rem;
      color: #027cfa;
    }
    img {
      width: 0.68rem;
      height: 0.64rem;
    }
  }
}
</style>
